<template>
    <div >
        <a v-bind:href="imageSource" v-bind:title="imageSource" target="_blank" rel="opener" opener="rel">
            <img class="img-thumbnail" id="person-photo" v-bind:data-ccn="ccn" v-bind:data-nameid="nameid" v-bind:data-ori="ori" v-bind:src="imageSource" v-bind:width="width" v-bind:height="height" loading="lazy" />
        </a>
    </div>
</template>

<script>
    export default {
        props: ['ori', 'ccn', 'width', 'height', 'nameid', 'skip_auth'],
        data() {
            return {
                imageSource: ''
            };
        },
        watch: {
            //ccn: async function (newValue) {
            //    this.getPhoto(this.ori, newValue, this.nameid);
            //}
        },
        computed() {

        },
        methods: {
            setImageSource: function (src) {
                this.imageSource = src;
            },

            getPhoto: function (ori, ccn) {
                var vue = this;

                if (ccn === null || typeof (ccn) === "undefined") {
                    this.setImageSource('/images/demophoto1.png');
                    return;
                }

                this.setImageSource(`/images/photoLoadGif.gif`);

                var photoUrl = `${process.env.VUE_APP_API_ENDPOINT}/Roster/GetPhoto?ori=${ori}&ccn=${ccn}`;

                this.$http.get(photoUrl).then(function () {
                    //console.log('web request success');
                    console.log('photo url = ' + photoUrl)
                    this.setImageSource(photoUrl);
                    //check for sepecific exception and then
                }).catch(function () {

                    vue.setImageSource('/images/demophoto1.png');
                });
            }
        },
        created() {

        },
        mounted() {

        }
    }
</script>

<style>
</style>